export function initTabsContent() {
  document.addEventListener('DOMContentLoaded', function () {


    // const tabs = document.querySelectorAll('.blockProductSliders');
    // tabs.forEach(single => {
    //   const parentUniqueId = single.id;
    //   console.log(parentUniqueId)

    //   const allTabs = document.querySelectorAll(`#${parentUniqueId} .tabsContentBox`);
    //   allTabs.forEach(singleTab => {
    //     const tabList = document.querySelectorAll(`#${parentUniqueId} .tabsContent__item`);
    //     const tabsContent = document.querySelector(`#${parentUniqueId} .tabsContent`);

    //     const categoryLinks = document.querySelectorAll(`#${parentUniqueId} .tabsContent__link--category`);


    //     let tabsSlider = new window.splide(tabsContent, {
    //       pagination: false,
    //       arrows: false,
    //       autoWidth: true,
    //       drag: true
    //     });

    //     tabsSlider.on('overflow', function (isOverflow) {
    //       if (isOverflow) {
    //         tabsContent.querySelector('.tabsContent__list').classList.remove('center');

    //       } else {
    //         tabsContent.querySelector('.tabsContent__list').classList.add('center');

    //       }

    //       tabsSlider.options = {
    //         drag: isOverflow,
    //         clones: isOverflow ? undefined : 0,
    //       };
    //     });


    //     function handleCategoryClick(event) {
    //       const clickedCategory = event.target.dataset.id;
    //       const categoryContent = document.querySelectorAll(`#${parentUniqueId} .tabsContent__wrap`);
    //       if (singleTab.classList.contains('tabsContentBox--links')) {
    //         const clickedCategoryLink = event.target.dataset.link;
    //         const categoryLinks = document.querySelectorAll(`#${parentUniqueId}.blockProductSliders__link`);

    //         if (categoryLinks) {
    //           console.log(clickedCategoryLink);
    //           categoryLinks.forEach(categoryLink => {
    //             categoryLink.classList.remove('active');
    //           });

    //           const linkToShow = document.getElementById(clickedCategoryLink);
    //           linkToShow.classList.add('active');
    //         }
    //       }

    //       categoryContent.forEach(category => {
    //         category.classList.remove('active');
    //       });

    //       const contentToShow = document.getElementById(clickedCategory);
    //       contentToShow.classList.add('active');
    //     }

    //     categoryLinks.forEach(categoryLink => {
    //       categoryLink.addEventListener('click', handleCategoryClick);
    //     });

    //     tabsSlider.on('click', function (slide) {
    //       tabList.forEach(tab => {
    //         tab.classList.remove('is-active');
    //       });

    //       tabsSlider.go(slide.index);
    //     });

    //     tabsSlider.mount();
    //   });
    // });

    const allTabs = document.querySelectorAll('.tabsContentBox');
    allTabs.forEach(singleTab => {
      // const parentUniqueId = singleTab.closest('.blockProductSliders').id;
      // console.log('id', parentUniqueId)
      const tabList = singleTab.querySelectorAll('.tabsContent__item');
      const tabsContent = singleTab.querySelector('.tabsContent');

      const categoryLinks = singleTab.querySelectorAll('.tabsContent__link--category');


      let tabsSlider = new window.splide(tabsContent, {
        pagination: false,
        arrows: false,
        autoWidth: true,
        drag: true
      });

      tabsSlider.on('overflow', function (isOverflow) {
        if (isOverflow) {
          tabsContent.querySelector('.tabsContent__list').classList.remove('center');

        } else {
          tabsContent.querySelector('.tabsContent__list').classList.add('center');

        }

        tabsSlider.options = {
          drag: isOverflow,
          clones: isOverflow ? undefined : 0,
        };
      });


      function handleCategoryClick(event) {
        const clickedCategory = event.target.dataset.id;
        const categoryContent = singleTab.querySelectorAll('.tabsContent__wrap');

        if (singleTab.classList.contains('tabsContentBox--links')) {
          const parentUniqueId = singleTab.closest('.blockProductSliders').id;
          const clickedCategoryLink = event.target.dataset.link;
          const categoryLinks = document.querySelectorAll(`#${parentUniqueId} .blockProductSliders__link`);

          if (categoryLinks.legth > 0) {
            categoryLinks.forEach(categoryLink => {
              categoryLink.classList.remove('active');
            });

            const linkToShow = document.getElementById(clickedCategoryLink);
            linkToShow.classList.add('active');
          }
        }

        categoryContent.forEach(category => {
          category.classList.remove('active');
        });

        const contentToShow = document.getElementById(clickedCategory);
        contentToShow.classList.add('active');
      }

      categoryLinks.forEach(categoryLink => {
        categoryLink.addEventListener('click', handleCategoryClick);
      });

      tabsSlider.on('click', function (slide) {
        tabList.forEach(tab => {
          tab.classList.remove('is-active');
        });

        tabsSlider.go(slide.index);
      });

      tabsSlider.mount();
    });

  });

}
